import { render, staticRenderFns } from "./BasicLogin.vue?vue&type=template&id=3a4a99b9&scoped=true&"
import script from "./BasicLogin.vue?vue&type=script&lang=js&"
export * from "./BasicLogin.vue?vue&type=script&lang=js&"
import style0 from "./BasicLogin.vue?vue&type=style&index=0&id=3a4a99b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4a99b9",
  null
  
)

export default component.exports